$shm_projects_docs $shm_hitalama_textbook
	readme_text \
	agents_text \
	text <= mode_text \
	Modes $mol_view
		sub /
			<= Readme $mol_link
				current <= readme_current false
				arg *
					docs_file null
				title \readme
				sub / \readme
			<= Agents $mol_link
				current <= agents_current false
				arg *
					docs_file \agents
				title \AGENTS
				sub / \AGENTS
